"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isIterable(input) {
    if (input) {
        return input[Symbol.iterator] !== undefined;
    }
    return false;
}
exports.isIterable = isIterable;
//# sourceMappingURL=IsIterable.js.map